import React, { useEffect, useState } from 'react';

import styles from '../index.pcss';
import classNames from 'classnames/bind';
import Text from '../../../atoms/Text';
import Button from '../../../atoms/button';
import AddressList from '../../../../myaccount/components/mobile/CartAddressList/AddressList';
import { gtmEventPush, segmentEventPush, rushAddressBarEvents } from '../../../../modules/ga/GTMdatalayer';
import properties from '../../../../modules/ajio-util/properties';
import { replaceWithJioCDN } from '../../../../utils/imageHandling';

const cx = classNames.bind(styles);

const SelectAddressDialog = (props: {
  locationState: any;
  setShowAddressList: any;
  setShowAddressBarDialog: any;
  setShowFetchingPincodeCard: any;
  currentLocationURL: any;
  currentLocationLuxeURL: any;
  logoURL: any;
  allowUserLocation: any;
  luxe: any;
  addressListLoader: any;
  addressList: any;
  fromCart: any;
  changeAddress: any;
  setAddressSelected: any;
  handleAddressUpdate: any;
  signInCheck: any;
  setPincodeCardVisibility: any;
  setPincodeError: any;
  setPincodeErrorMsg: any;
  setShowAddAddress: any;
  setConfirmPincodeCardVisibility: any;
  setFetchedLocationData: any;
  enableDeviceLocation: any;
  enableRushDelivery?:boolean;
  suggestions?:any;
  selectPlace?: (...args: any[])=> void | any;
  getUserCoords?: (...args: any[])=> void | any;
  getPlaceDetails?: (...args: any[])=> void | any;
  setIsAddAddress?:any;
  isAddAddress?:boolean;
  setIsCurrentLocationButtonDisabled?:any;
  chechRushAvailability?:any;
  getLocationDetailsFromAddress?: any;
  locationSearchQuery?:any;
  fleek?:any;
  currentLocationURLFleek?:any;
  handleButtonClick?:(...args: any[])=> void | any;
  isAddAddressDisabled?:any;
  setIsAddAddressDisabled?:any;
  postalCodeSecondary?:any;
  postalCode?:any;
  setGeoTagFromCart?:any;
  geoTagFromCart?:any;
  isBilling?:boolean;
}) => {
  let {
    locationState,
    setShowAddressList,
    setShowAddressBarDialog,
    setShowFetchingPincodeCard,
    currentLocationURL,
    currentLocationLuxeURL,
    logoURL,
    allowUserLocation,
    luxe,
    addressListLoader,
    addressList,
    fromCart,
    changeAddress,
    setAddressSelected,
    handleAddressUpdate,
    signInCheck,
    setPincodeCardVisibility,
    setPincodeError,
    setPincodeErrorMsg,
    setShowAddAddress,
    setConfirmPincodeCardVisibility,
    setFetchedLocationData,
    enableDeviceLocation,
    enableRushDelivery = false,
    suggestions,
    selectPlace,
    getUserCoords,
    setIsAddAddress,
    isAddAddress,
    setIsCurrentLocationButtonDisabled,
    chechRushAvailability,
    getLocationDetailsFromAddress,
    locationSearchQuery,
    fleek,
    currentLocationURLFleek,
    handleButtonClick,
    isAddAddressDisabled,
    setIsAddAddressDisabled,
    postalCodeSecondary,
    postalCode,
    getPlaceDetails,
    setGeoTagFromCart,
    geoTagFromCart,
    isBilling = false
  } = props;

const imageBaseUrl = properties.getProperty('imageBaseUrl');
const [rushRecentSearches, setRushRecentSearches ] = useState<any>();



  const handleAddAddress = () => {
    if (enableRushDelivery) {
      //no need for closing these states in rush....need them opened behind add address dialog box
      if (handleButtonClick) {
        setIsAddAddressDisabled(true);
        handleButtonClick();
        setIsAddAddress(true);
      } else {
        setShowAddressList(false);
        setShowAddressBarDialog?.(false);
        setShowAddAddress(true);
      }
    }
    else{
      // locationState === 'granted' && setIsCurrentLocationButtonDisabled(()=>true);
      const isUserLoggedIn = signInCheck();
      if(isUserLoggedIn && handleButtonClick){                            //only perform function when location permission is granted
        setIsAddAddressDisabled(true);
        handleButtonClick();
        setIsAddAddress(true);
      }
      else if(getUserCoords) {
        getUserCoords(true);
      } else {
        // Fallback: directly open add address dialog when handleButtonClick and getUserCoords are not available
        setShowAddressList(false);
        setShowAddressBarDialog?.(false);
        setShowAddAddress(true);
      }
    }

    gtmEventPush({
      event: 'buttonTap',
      event_category: 'buttonTap',
      event_action: 'add new address',
      page_name: 'Enable location screen'
    });

  
  };

  const handleEnterPincode = () => {
    setShowAddressList(false);
    setShowAddressBarDialog?.(false);
    setPincodeCardVisibility(true);
    setPincodeError(false);
    setPincodeErrorMsg('');

    gtmEventPush({
      event: 'buttonTap',
      event_category: 'buttonTap',
      event_action: 'enter pincode',
      page_name: 'Enable location screen'
    });

     segmentEventPush({
      event:'Pincode Checked or Changed',
      cta_name: 'Enter new pincode',            
                    
      screen_name: 'Enable location screen'
    });
   
  };
  

  useEffect(()=>{                                                     //useEffect for getting recent searches
    if(enableRushDelivery){
      let recentSearches = JSON.parse(localStorage.getItem('rushRecentSearches')) || [];        //local storage variable for recent searches in rush
      if(recentSearches){
        setRushRecentSearches(recentSearches);
      }
    }
  },[]);

  const rushSelectLocation = async(locationFetched:any, isAddAddressDisabled:boolean) => {                               //when user selects any google search suggestions for rush
    if(isAddAddressDisabled && locationState !== 'granted'){      //when add address not true and location not granted
      setIsAddAddress(true);
    }
    if(selectPlace) {
      let locationData = null;
      if(!locationFetched.address_components && ((isAddAddressDisabled && locationState !== 'granted') || isAddAddress) && getPlaceDetails){
        locationData = await getPlaceDetails(locationFetched.place_id);
      }
      let selectPlaceAttributes = await selectPlace(locationFetched.place_id, locationData || locationFetched, (((isAddAddressDisabled && locationState !== 'granted') || isAddAddress || fromCart)?true:false) );
      rushAddressBarEvents("selectRushAddress", { source: "search_suggestion_clicked", pincode: selectPlaceAttributes?.pincode });
      let recentSearches = JSON.parse(localStorage.getItem('rushRecentSearches')) || [];
      let {structured_formatting: {main_text = '', secondary_text = ''} = {}} = locationFetched;
      let newRecentSearchEntry = {LocationName: main_text, LocationAddress: secondary_text,pincode:(!selectPlaceAttributes?.addressLine.includes("India")? "" : selectPlaceAttributes?.pincode || postalCode || postalCodeSecondary), ...locationFetched};
      recentSearches.unshift(newRecentSearchEntry);
      localStorage.setItem('rushRecentSearches',JSON.stringify(recentSearches));
    }
  }

  const recentSearchClicked = async(recentLocation:any) => {               //if user clicks on any recent searches shown

    let locationData = null;
      if(!recentLocation.address_components && ((isAddAddressDisabled && locationState !== 'granted') || isAddAddress) && getPlaceDetails){
        locationData = await getPlaceDetails(recentLocation.place_id);
      }
    if(selectPlace) {
      let currPincodeGA = await selectPlace(recentLocation.place_id, locationData || recentLocation, isAddAddress || fromCart);
      rushAddressBarEvents("selectRushAddress", { source: "recent_search_clicked", pincode: currPincodeGA?.pincode });
    }
  }

  return (
    <div className={cx('dialog-container', { 'dialog-container-rush': enableRushDelivery }, { 'dialog-container-rush-fleek': enableRushDelivery && fleek })} id="address-dialog">
      {locationState === 'granted' ? (
        <div
          className={cx('current-location-div', { 'current-location-div-rush': enableRushDelivery },{'current-location-div-fleek-rush': enableRushDelivery && fleek}, {'current-location-div-nobottomMargin-rush': enableRushDelivery && addressList?.addresses?.length === 0 && (rushRecentSearches && rushRecentSearches?.length>0) })}         //for rush -> when only recent searches is there no bottom margin
          style={{
            marginBottom:
              addressList?.addresses?.length === 0
              && !enableRushDelivery
                ? Boolean(signInCheck())
                  ? '94px'
                  : '34px'
                : '0px'
          }}
          onClick={() => {
            setShowAddressList(false);
            setShowAddressBarDialog?.(false);
            setShowFetchingPincodeCard(true);
            if(enableRushDelivery && getUserCoords){                                 //for rush need only lat and long needed
              locationState === 'granted' && setIsCurrentLocationButtonDisabled(()=>true);
              getUserCoords(isAddAddress, true);
              // setIsAddAddress(false);            //not completly removing this
            }
            else{
              allowUserLocation((data: any) => {
                setFetchedLocationData(data);
                setShowFetchingPincodeCard(false);
                setConfirmPincodeCardVisibility(true);
              });
            }
            gtmEventPush({
              event: 'address_interaction',
              event_category: 'address interaction',
              event_action: 'use your current location',
              page_name: 'Check out Address delivery'
            });
          }}
        >
          <img
            src={luxe && !enableRushDelivery ? replaceWithJioCDN(currentLocationLuxeURL) : replaceWithJioCDN(fleek ? currentLocationURLFleek : currentLocationURL)}
            aria-hidden="true"
            alt="current-location-logo"
            className={cx('current-location-img')}
          />
          <span className={cx('current-location-text', { 'luxe-current-location-text': luxe && !enableRushDelivery},{ 'current-location-text-rush-fleek':enableRushDelivery && fleek})} role='button' tabIndex={0}>
            Use your current location
          </span>
          {enableRushDelivery && <img
            src={fleek ? `${imageBaseUrl}/static/img/chevronRightRushFleek.svg` : `${imageBaseUrl}/static/img/chevronRight.svg`}
            aria-hidden="true"
            alt="Chevron Right icon"
            className={cx('chevronRightRush')}
          />}
        </div>
      ) : (
      <>
      { enableRushDelivery ?
              <div
                className={cx('enable-location-div-rush')}
                // style={{
                //   marginBottom:
                //     addressList?.addresses?.length === 0
                //       ? Boolean(signInCheck())
                //         ? '94px'
                //         : '34px'
                //       : '0px'
                // }}
              >
                <img src={logoURL} alt="enable-location-logo" aria-hidden="true" className={cx('enable-location-img-rush')} />
                <div>
                  <p className={cx('enable-location-text-rush')}>Current Location</p>
                  <p className={cx('enable-location-subtext-rush')}>
                    Enable your current location for accurate delivery results
                  </p>
                  <div className="refreshBtn">
                    <button
                      className={cx('refreshBtn-rush')}
                      aria-label="Enable Location"
                      onClick={()=>{enableDeviceLocation();rushAddressBarEvents("locationEnableClick");}}
                    >
                      Enable Location
                    </button>
                  </div>
                </div>
              </div>
      : 
        <div
          className={cx('enable-location-div')}
          style={{
            marginBottom:
              addressList?.addresses?.length === 0
              && !enableRushDelivery
                ? Boolean(signInCheck())
                  ? '94px'
                  : '34px'
                : '0px'
          }}
        >
          <img src={replaceWithJioCDN(logoURL)} alt="enable-location-logo" className={cx('enable-location-img')} />
          <div>
            <p className={cx('enable-location-text')}>Device Location is Off</p>
            <p className={cx('enable-location-subtext')}>
              Please enable your location services for better delivery experience
            </p>
            <div className="refreshBtn">
              <Button
                ariaLabel="Enable Location"
                variant="primary"
                fullWidth
                btnLabel="Enable Location"
                customClass={luxe ? cx('luxe-btn') : ''}
                onClick={enableDeviceLocation}
                emphasis={!!luxe}
              />
            </div>
          </div>
        </div>
        }</>
      )}
      {enableRushDelivery && 
      !isAddAddressDisabled &&
      <div className={cx('dialog-links-container-rush')}>              {/* add address for Rush */}
        {Boolean(signInCheck()) && (
          <div className={cx("add-address-link-rush", (luxe && !enableRushDelivery? "luxe-add-address-link" : "add-address-link"), {'add-address-link-rush-fleek':fleek})} onClick={handleAddAddress}>
            <img
              src={fleek ? `${imageBaseUrl}/static/img/yellowPlusRush.svg` :`${imageBaseUrl}/static/img/BluePlus.svg`}
              alt="Blue Plus icon"
              className={cx('bluePlusRush')}
            />
            <span
              className={cx("add-address-rush",{'add-address-rush-fleek':fleek})}
            >
              Add new address
            </span>
          </div>
        )}
      </div>}
      {luxe && <div className={cx('luxe-dialog-divider')}></div>}
      { enableRushDelivery && (suggestions && suggestions.length > 0 &&
        <div className={cx('search-suggestions-container-rush')} role='list'>
          {suggestions?.map((location: any) => {
            return (
              <div key={location?.structured_formatting?.main_text} className={cx('recent-searches-addresses-boxContainer-rush')} onClick={()=>{rushSelectLocation(location,isAddAddressDisabled);}} role='listitem'>
                <img
                  src={fleek ? `${imageBaseUrl}/static/img/location_white.svg` : `${imageBaseUrl}/static/img/location_black.svg`}
                  aria-hidden="true"
                  alt="Location Icon"
                  className={cx('recentSearchIcon-rush')}
                />
                <div className={cx('recent-searches-addresses-box-rush')} tabIndex={0} role='button' aria-label={`${location?.structured_formatting?.main_text} - ${location?.structured_formatting?.secondary_text}`}>
                  <div className={cx('recent-searches-locationName-rush', { 'ajiogram': fleek })} aria-hidden="true">{location?.structured_formatting?.main_text}</div>
                  <div className={cx('recent-searches-locationAddress-rush', {'recent-searches-locationAddress-rush-fleek':fleek})} aria-hidden="true">{location?.structured_formatting?.secondary_text}</div>
                </div>
              </div>
            );
          })}
        </div>)
      }
      {enableRushDelivery && (locationSearchQuery && locationSearchQuery?.length>=3) &&   //condition for -> when no search suggestions are there for rush
          (!suggestions || suggestions?.length ===0) ? null : Boolean(signInCheck()) &&
        (addressListLoader ? (
          <div className={cx('address_shimmer')}>
            <div className={cx('header')}>
              <div className={cx('ldr')} />
            </div>
            <div className={cx('luxe-dialog-divider')} />
            <div className={cx('body')}>
              <div className={cx('details')}>
                <div className={cx('ldr')} />
                <div className={cx('ldr')} />
                <div className={cx('ldr')} />
              </div>
              <div className={cx('details')}>
                <div className={cx('ldr')} />
                <div className={cx('ldr')} />
                <div className={cx('ldr')} />
              </div>
              <div className={cx('details')}>
                <div className={cx('ldr')} />
                <div className={cx('ldr')} />
                <div className={cx('ldr')} />
              </div>
            </div>
            <div className={cx('luxe-dialog-divider')} />
            <div className={cx('header')}>
              <div className={cx('ldr')} />
            </div>
            <div className={cx('luxe-dialog-divider')} />
            <div className={cx('header')}>
              <div className={cx('ldr')} />
            </div>
            <div className={cx('luxe-dialog-divider')} />
          </div>
        ) : (
          <>
            {addressList?.addresses?.length > 0 && (
              <>
                <Text
                  variant="T4"
                  color={luxe && !enableRushDelivery? 'Light_Black' : (fleek && enableRushDelivery? 'white' : 'Nero')}
                  weight="bold"
                  textTransform={luxe && !enableRushDelivery? 'is-uppercase' : 'none'}
                  customClass={cx('delivery-address-text')}
                  role='heading'
                  ariaLevel={3}
                >
                  {enableRushDelivery ? 'Saved Addresses' : 'Choose a Delivery Address'}
                </Text>
                <AddressList
                  addressList={addressList}
                  luxe={luxe}
                  fromCart={fromCart}
                  updateAddressOnCart={changeAddress}
                  setShowAddressList={setShowAddressList}
                  setShowAddressBarDialog={setShowAddressBarDialog}
                  setAddressSelected={setAddressSelected}
                  handleAddressUpdate={handleAddressUpdate}
                  isFromPDPhase2
                  enableRushDelivery={enableRushDelivery}
                  chechRushAvailability={chechRushAvailability}
                  getLocationDetailsFromAddress={getLocationDetailsFromAddress}
                  selectPlace={selectPlace}
                  fleek={fleek}
                  setGeoTagFromCart={setGeoTagFromCart}
                  geoTagFromCart={geoTagFromCart}
                  setIsAddAddress={setIsAddAddress}
                  isBilling={isBilling}
                />
              </>
            )}
          </>
        ))}
      {luxe && <div className={cx('luxe-dialog-divider')}></div>}
      {enableRushDelivery ? (rushRecentSearches && rushRecentSearches.length > 0 && 
      <>
      {
        (locationSearchQuery && locationSearchQuery?.length>=3) &&            //when no search result is there condition
        (!suggestions || suggestions?.length ===0) ? null :
        <div className={cx('recent-searches-container-rush')}>
          <div className={cx('recent-searches-header-rush', { 'ajiogram': fleek })} role='heading' aria-level={3}>Recent Searches</div>
          {rushRecentSearches?.map((location: any,index:number) => {
            if(index>4){
              return <></>;
            }
            return (
              <div key={location?.LocationAddress} className={cx('recent-searches-addresses-boxContainer-rush')} onClick={()=>recentSearchClicked(location)}>         {/*todo on click to fetch address */}
                <img
                  src={fleek ? `${imageBaseUrl}/static/img/location_white.svg` : `${imageBaseUrl}/static/img/location_black.svg`}
                  alt="Location Icon"
                  className={cx('recentSearchIcon-rush')}
                />
                <div className={cx('recent-searches-addresses-box-rush')}>
                  <div className={cx('recent-searches-locationName-rush', { 'ajiogram': fleek })}>{location?.LocationName}</div>
                  <div className={cx('recent-searches-locationAddress-rush', {'recent-searches-locationAddress-rush-fleek':fleek})}>{location?.LocationAddress}</div>
                </div>
              </div>
            );
          })}
        </div>}
        </> )
      :
      <div className={cx('dialog-links-container')}>
        {Boolean(signInCheck()) && (
          <p
            className={cx(luxe ? 'luxe-add-address-link' : 'add-address-link')}
            onClick={handleAddAddress}
            role="button"
            tabIndex={0}
          >
            Add new address
          </p>
        )}
        {Boolean(signInCheck()) && luxe && <div className={cx('luxe-dialog-divider')}></div>}
        <p
          className={cx(luxe ? 'luxe-add-address-link' : 'new-pin-link')}
          onClick={handleEnterPincode}
          role="button"
          tabIndex={0}
        >
          Enter new pincode
        </p>
      </div>}
    </div>
  );
};

export default SelectAddressDialog;
